import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import { Group, Radio, Modal } from "@mantine/core";
import AsyncSelect from "react-select/async";
import CustomDateAndTime from "../../../../../../components/customDateAndTime/CustomDateAndTime";
import { DatePicker, TimeInput } from "@mantine/dates";
import { ReactComponent as DateIcon } from "../../../../../../assets/fi-rr-calendar.svg";
import CustomButton from "../../../../../../components/CustomButton";
import CustomDOBPicker from "../../../../../../components/CustomDOBPicker";
import { useForm, Controller, useWatch, useFormContext, useFieldArray } from "react-hook-form";
import { Box } from "@mantine/core";
import RHFAsyncFlightSelect from "../../../../../../components/form/RHFAsyncFlightSelect";
import RHFTextInput from "../../../../../../components/form/RHFTextInput";
import RHFNumberInput from "../../../../../../components/form/RHFNumberInput";
import RHFSelect from "../../../../../../components/form/RHFSelect";
import RHFRadioGroup from "../../../../../../components/form/RHFRadioGroup";
import RHFTextarea from "../../../../../../components/form/RHFTextarea";
import RHFCustomDatePicker from "../../../../../../components/form/RHFCustomDatePicker";
import RHFTimeInput from "../../../../../../components/form/RHFTimeInput";
import { RemoveCircleOutline } from "@mui/icons-material";
import { calculateDelayDuration, dateFormat, fetchAirlines, fetchAirports, isValidTime } from "../../../../../../components/utils/flightApiUtils";
import moment from "moment";

import axios from "axios";
import base_url from "../../../../../../api/bootapi";
import Swal from "sweetalert2";
import { useMediaQuery } from "@mantine/hooks";


const FlightItem = ({ index, remove, claimType, defaultAirlines, defaultAirports, openFlightModal, setLoading }) => {

  const { watch, setValue, control, formState: { errors } } = useFormContext();

  // const [loading, setLoading] = useState(false)


  const loadAirlineOptions = (inputValue, search_by) => {
    return fetchAirlines(inputValue, search_by); // Just return the promise
  };

  const loadOptions = (inputValue) => {
    return fetchAirports(inputValue); // Just return the promise
  };

  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    if (ddmmyyyy.test(value) || yyyymmdd.test(value)) {
      return true;
    }

    return "Date must be in mm-dd-yyyy format";
  };
  // Find this at the top of your FlightItem component
  const statusIssue = watch(`original_flight_details.${index}.status_issue`);

  // Map them to booleans for your conditional rendering
  const isDelayed = statusIssue === "delayed";
  const isCancelled = statusIssue === "cancelled";
  const isMissed = statusIssue === "missed";



  const flight = useWatch({
    control,
    name: `original_flight_details.${index}`
  });

  const fetchFlightDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/flight_states`,
        {
          airline_code: flight?.hub_code,
          flight_number: flight.flight_number,
          flight_date: moment(flight.date_of_travel).format("YYYY-MM-DD"),
        }
      );

      const flightOptionsData = response?.data?.Flight?.map((flightData) => {
        const departureScheduled = flightData.departure.scheduled;
        const departureActual = flightData.departure.actual;
        const departureActualRunway = flightData.departure.actual_runway;

        const arrivalScheduled = flightData.arrival.scheduled;
        console.log(arrivalScheduled)
        const arrivalActual = flightData.arrival.actual;
        const arrivalActualRunway = flightData.arrival.actual_runway;

        const delayDuration = calculateDelayDuration(arrivalScheduled, arrivalActual || arrivalActualRunway);
        return {
          value: `${flightData.departure.iata}-${flightData.arrival.iata}`,
          departure: {
            airport: flightData.departure.airport,
            iata: flightData.departure.iata,
            departureScheduled,
            timeZone: flightData.departure.timezone,
            departureActual: departureActual || departureActualRunway,
          },
          arrival: {
            airport: flightData.arrival.airport,
            iata: flightData.arrival.iata,
            arrivalScheduled,
            timeZone: flightData.arrival.timezone,

            arrivalActual: arrivalActual || arrivalActualRunway,
          },
          delay_cal: delayDuration,
          label: `${flightData.arrival.airport} - ${flightData.departure.airport}`,
        };
      });

      const flights = response.data.Flight;
      if (!flights.length) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Flight not found`,
        })

        resetFlight();

        return;
      }

      if (flights.length > 1) {
        openFlightModal(flights, `original_flight_details.${index}`, flightOptionsData);
        return;
      }

      updateFlight(flightOptionsData[0]);


    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Flight not found`,
      })

      resetFlight()
      console.log(e);
    } finally {
      setLoading(false);

    }
  };

  const resetFlight = () => {
    const basePath = `original_flight_details.${index}`;

    // Reset standard text fields
    setValue(`${basePath}.airport_of_origin`, "");
    setValue(`${basePath}.airport_of_destination`, "");
    setValue(`${basePath}.departure_iata_code`, "");
    setValue(`${basePath}.arrival_iata_code`, "");
    setValue(`${basePath}.delay_cal`, 0);

    // Reset Original (Scheduled) Dates & Times
    setValue(`${basePath}.original_departure_time`, "");
    setValue(`${basePath}.original_departure_date`, "");
    setValue(`${basePath}.original_arrival_time`, "");
    setValue(`${basePath}.original_arrival_date`, "");

    // Reset Actual Dates & Times
    setValue(`${basePath}.actual_departure_time`, "");
    setValue(`${basePath}.actual_departure_date`, "");
    setValue(`${basePath}.actual_arrival_time`, "");
    setValue(`${basePath}.actual_arrival_date`, "");
  };

  const updateFlight = (flight) => {
    const basePath = `original_flight_details.${index}`;

    // 2. Extract values from your JSON payload
    const depScheduled = flight?.departure?.departureScheduled;
    const depActual = flight?.departure?.departureActual;
    const depTz = flight?.departure?.timeZone;

    const arrScheduled = flight?.arrival?.arrivalScheduled;
    const arrActual = flight?.arrival?.arrivalActual;
    const arrTz = flight?.arrival?.timeZone;

    // 3. Set standard text fields
    setValue(`${basePath}.airport_of_origin`, flight?.departure?.airport || "");
    setValue(`${basePath}.airport_of_destination`, flight?.arrival?.airport || "");
    setValue(`${basePath}.departure_iata_code`, flight?.departure?.iata || "");
    setValue(`${basePath}.arrival_iata_code`, flight?.arrival?.iata || "");
    setValue(`${basePath}.delay_cal`, flight?.delay_cal || 0);

    // 4. Set Original (Scheduled) Departure Date & Time
    if (isValidTime(depScheduled)) {
      const formattedDepScheduled = dateFormat(depScheduled, depTz);
      setValue(`${basePath}.original_departure_time`, formattedDepScheduled.time);
      setValue(`${basePath}.original_departure_date`, formattedDepScheduled.date);
    } else {
      setValue(`${basePath}.original_departure_time`, "");
      setValue(`${basePath}.original_departure_date`, "");
    }

    // 5. Set Original (Scheduled) Arrival Date & Time
    if (isValidTime(arrScheduled)) {
      const formattedArrScheduled = dateFormat(arrScheduled, arrTz);
      setValue(`${basePath}.original_arrival_time`, formattedArrScheduled.time);
      setValue(`${basePath}.original_arrival_date`, formattedArrScheduled.date);
    } else {
      setValue(`${basePath}.original_arrival_time`, "");
      setValue(`${basePath}.original_arrival_date`, "");
    }

    // 6. Set Actual Departure Date & Time
    if (isValidTime(depActual)) {
      const formattedDepActual = dateFormat(depActual, depTz);
      setValue(`${basePath}.actual_departure_time`, formattedDepActual.time);
      setValue(`${basePath}.actual_departure_date`, formattedDepActual.date);
    } else {
      setValue(`${basePath}.actual_departure_time`, "");
      setValue(`${basePath}.actual_departure_date`, "");
    }

    // 7. Set Actual Arrival Date & Time
    if (isValidTime(arrActual)) {
      const formattedArrActual = dateFormat(arrActual, arrTz);
      setValue(`${basePath}.actual_arrival_time`, formattedArrActual.time);
      setValue(`${basePath}.actual_arrival_date`, formattedArrActual.date);
    } else {
      setValue(`${basePath}.actual_arrival_time`, "");
      setValue(`${basePath}.actual_arrival_date`, "");
    }
  };

  const isValidDate = (str) => {
    return moment(str, "MM-DD-YYYY", true).isValid();
  };

  console.log(flight?.date_of_travel)
  useEffect(() => {
    if (
      flight?.date_of_travel &&
      isValidDate(flight?.date_of_travel) &&
      flight?.airline &&
      flight?.hub_code &&
      flight?.triggered &&
      flight?.flight_number
    ) {
      fetchFlightDetails();
    }
  }, [
    flight?.date_of_travel,
    flight?.airline,
    flight?.flight_number,
    flight?.hub_code,
    flight?.triggered
  ]);


  const isManual = watch('original_flight_details.is_manual')



  return (
    <div key={index}>
      <div className="flight-add-wrapper">
        <h3>Flight {index + 1}</h3>
        {index > 0 && (
          <div
            style={{
              backgroundColor: "none",
              color: "red",
              cursor: "pointer",
              marginLeft: "2px",
              textAlign: "right",
            }}
            onClick={() => remove(index)}
          >
            <RemoveCircleOutline />
          </div>
        )}
      </div>

      <div className="claim-grid" style={{ marginBottom: '20px' }}>
        <div className="custom-input">

          <label className="input-label">
            Search by

          </label>

          <Controller
            name={`original_flight_details.${index}.search_by`}
            control={control}
            render={({ field }) => (
              <Radio.Group
                {...field}
              >
                <div className="claim-form-radio-wrapper">

                  <Radio
                    color="red"
                    variant="outline"
                    value={"airline_name"}
                    label="Airline name"
                    size="xs"
                  />

                  <Radio
                    color="red"
                    variant="outline"
                    value={"iata_code"}
                    label="Airline code"
                    size="xs"

                  />
                </div>
              </Radio.Group>
            )}
          />



        </div>





      </div>
      <div className="claim-grid">
        <RHFAsyncFlightSelect
          name={`original_flight_details.${index}.airline`}
          label="Airline"
          withAsterisk
          rules={{ required: "Airline is required" }}
          defaultOptions={defaultAirlines}
          loadOptions={(val) => loadAirlineOptions(val, watch(`original_flight_details.${index}.search_by`))}
          onChangeCallback={(selectedOption) => {

            setValue(`original_flight_details.${index}.triggered`, true);

            setValue(`original_flight_details.${index}.hub_code`, selectedOption?.hub_code);


          }}
        />

        <RHFNumberInput
          name={`original_flight_details.${index}.flight_number`}
          label="Flight Number (Digits only)"
          placeholder='Enter flight number'
          withAsterisk
          maxLength={10}
          rules={{
            required: "Flight Number is Required",
            pattern: { value: /^[a-zA-Z0-9]+$/, message: "Only alphanumeric characters allowed" }
          }}
          onChange={(e) => {
            setValue(`original_flight_details.${index}.triggered`, true);

            // Force uppercase alphanumeric directly into RHF state
            setValue(`original_flight_details.${index}.flight_number`, e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase());
          }}
        />


        <div className="new-claim-date-time-wrapper">
          <label className="custom-date-time-label" style={{ display: 'block', marginBottom: '8px' }}>
            Scheduled departure date & time <span style={{ color: "#de8385" }}>*</span>
          </label>

          <div style={{ position: "relative" }}>

            <div
              className="combined-datetime-pill"
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#e8eef7", // Matches the light grayish-blue in the image
                borderRadius: "999px",      // Creates the pill shape
                padding: "0px 16px",
                width: "100%",
                border: "1px solid #e8eef7", // Add a subtle border on focus if desired later
              }}
            >
              <RHFCustomDatePicker
                name={`original_flight_details.${index}.date_of_travel`}
                rules={{
                  required: "Travel Date is required",
                  validate: validateDateFormat, // Ensure you have this function defined
                }}

                placeholder="Choose date"
                hideError={true}

                // Mantine prop to remove borders and background
                variant="unstyled"

                // Override styles to ensure proper width and spacing
                styles={{
                  input: {
                    flex: 1,

                  },
                }}
                onValueChange={(value) => {
                  setValue(`original_flight_details.${index}.triggered`, true);
                }}
              />

              {/* 
        The calendar icon from RHFCustomDatePicker naturally sits between 
        these two inputs because it's set as the rightSection! 
      */}

              <RHFTimeInput
                name={`original_flight_details.${index}.original_departure_time`}
                rules={{ required: "Departure Time is required" }}

                placeholder="Time"
                hideError={true}
                readOnly={!watch(`original_flight_details.${index}.is_manual`)}




                // Mantine prop to remove borders and background
                variant="unstyled"

                styles={{
                  input: {
                    flex: 1,

                  }
                }}

              />
            </div>
          </div>

          {/* Error Message Display */}
          {(errors.original_flight_details?.[index]?.date_of_travel ||
            errors.original_flight_details?.[index]?.original_departure_time) && (
              <p className="errormessage" style={{ color: "red", fontSize: "12px" }}>
                {errors.original_flight_details?.[index]?.date_of_travel?.message ||
                  errors.original_flight_details?.[index]?.original_departure_time?.message ||
                  "Travel Date and Time is Required"}
              </p>
            )}
        </div>

        <RHFAsyncFlightSelect
          name={`original_flight_details.${index}.airport_of_origin`}
          label="Airport of Origin"
          withAsterisk

          isDisabled={!watch(`original_flight_details.${index}.is_manual`)}

          defaultOptions={defaultAirports} // Pass the hoisted data here
          loadOptions={loadOptions}
          rules={{ required: "Origin airport is required" }}
        />


        <div className="new-claim-date-time-wrapper">
          <label className="custom-date-time-label" style={{ display: 'block', marginBottom: '8px' }}>
            Scheduled arrival date & time <span style={{ color: "#de8385" }}>*</span>
          </label>

          <div style={{ position: "relative" }}>

            <div
              className="combined-datetime-pill"
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#e8eef7", // Matches the light grayish-blue in the image
                borderRadius: "999px",      // Creates the pill shape
                padding: "0px 16px",
                width: "100%",
                border: "1px solid #e8eef7", // Add a subtle border on focus if desired later
              }}
            >
              <RHFCustomDatePicker
                name={`original_flight_details.${index}.original_arrival_date`}
                rules={{
                  required: "Arrival Date is required",
                  validate: validateDateFormat, // Ensure you have this function defined
                }}

                placeholder="Choose date"
                hideError={true}
                readOnly={!watch(`original_flight_details.${index}.is_manual`)}
                hidePop={!watch(`original_flight_details.${index}.is_manual`)}



                // Mantine prop to remove borders and background
                variant="unstyled"

                // Override styles to ensure proper width and spacing
                styles={{
                  input: {
                    flex: 1,

                  },
                }}

              />

              {/* 
        The calendar icon from RHFCustomDatePicker naturally sits between 
        these two inputs because it's set as the rightSection! 
      */}

              <RHFTimeInput
                name={`original_flight_details.${index}.original_arrival_time`}
                rules={{ required: "Arrival Time is required" }}

                placeholder="Time"
                hideError={true}

                readOnly={!watch(`original_flight_details.${index}.is_manual`)}

                // Mantine prop to remove borders and background
                variant="unstyled"

                styles={{
                  input: {
                    flex: 1,

                  }
                }}

              />
            </div>
          </div>

          {/* Error Message Display */}
          {(errors.original_flight_details?.[index]?.original_arrival_date ||
            errors.original_flight_details?.[index]?.original_arrival_time) && (
              <p className="errormessage" style={{ color: "red", fontSize: "12px" }}>
                {errors.original_flight_details?.[index]?.original_arrival_date?.message ||
                  errors.original_flight_details?.[index]?.original_arrival_time?.message ||
                  "Arrival Date and Time is Required"}
              </p>
            )}
        </div>



        <RHFAsyncFlightSelect
          name={`original_flight_details.${index}.airport_of_destination`}
          label="Airport of Destination"
          withAsterisk
          isDisabled={!watch(`original_flight_details.${index}.is_manual`)}


          defaultOptions={defaultAirports} // Pass the hoisted data here
          loadOptions={loadOptions}
          rules={{ required: "Destination airport is required" }}
        />

        <RHFSelect
          name={`original_flight_details.${index}.flight_class`}
          label="Flight Class"
          withAsterisk
          data={[
            { label: "Economy", value: "Economy" },
            { label: "Business", value: "Business" },
            { label: "First Class", value: "First Class" }
          ]}
          rules={{ required: "Flight Class is required" }}
        />

        <div className="custom-input">

          <label className="input-label">Flight info didn't appear ?</label>
          <button className="btn btn-manual" type="button" onClick={() => {
            setValue(`original_flight_details.${index}.is_manual`, true, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }} >

            enter manually

          </button>

        </div>




      </div>

      {claimType !== "lost/damaged" && claimType !== "lost_wages" ? (
        <>
          <h2
            className="stepper-sub-header"
            style={{ marginBottom: "15px", marginTop: "30px" }}
          >
            What was the issue with this flight?
          </h2>

          <Group mb="sm" align="center">
            <RHFRadioGroup
              name={`original_flight_details.${index}.status_issue`}
              orientation="horizontal"

              options={[
                { label: "Flight delayed", value: "delayed" },
                { label: "Flight canceled", value: "cancelled" },
                { label: "Misconnection", value: "missed" },
                { label: "Denied Boarding", value: "denied" },
                { label: "Downgraded", value: "downgraded" },
                { label: "None of these", value: "none" }
              ]}
            />
          </Group>

          <h4
            className="stepper-sub-sub-header"
            style={{ marginBottom: "15px", marginTop: "15px" }}
          >
            {isDelayed
              ? "How long was your delay? "
              : isCancelled
                ? "When were you informed about the cancellation?"
                : isMissed
                  ? "Why did you miss your flight? "
                  : ""}
          </h4>


          {/* DELAYED SUB-MENU */}
          {isDelayed && (
            <Group mt="sm">
              <RHFRadioGroup
                name={`original_flight_details.${index}.delay_duration`}
                orientation="horizontal"
                options={[
                  { label: "Less than 3 hours", value: "179" },
                  { label: "3-4 hours", value: "181" },
                  { label: "4+ hours", value: "241" },
                  { label: "None of these", value: "none" }

                ]}
              />
            </Group>
          )}

          {/* MISSED SUB-MENU */}
          {isMissed && (
            <Group mt="sm">
              <RHFRadioGroup
                name={`original_flight_details.${index}.missed_reason`}
                orientation="horizontal"
                options={[
                  { label: "Airline Action", value: "airline_error" },
                  { label: "Personal Reasons", value: "personal_error" },
                  { label: "None of these", value: "none" }

                ]}
              />
            </Group>
          )}

          {/* CANCELLED SUB-MENU */}
          {isCancelled && (
            <Group mt="sm">

              <RHFRadioGroup
                name={`original_flight_details.${index}.cancellation_timing`}
                orientation="horizontal"
                options={[
                  { label: "Cancellation info before 7 days", value: "cancellation_info_before_7_days" },
                  { label: "Cancellation info before 14 days", value: "cancellation_info_before_14_days" },
                  { label: "None of these", value: "none" }

                ]}
              />
            </Group>
          )}


        </>
      ) : null}

      <div style={{ marginTop: "30px" }}>
        <h4 className="stepper-sub-header">Additional details</h4>
        <RHFTextarea
          name={`original_flight_details.${index}.additional_details`}

          minRows={10}
        />
      </div>

      {/* <p style={{ marginTop: '10px', color: '#f23939' }}>If this was part of a connecting flight  journey, please enter the next flight in order</p> */}
    </div>
  )
}


const OriginallyBookedFlights = ({
  defaultAirlines, defaultAirports, openFlightModal, setLoading, setActive, setTemporaryOpened
}) => {

  const isMobile = useMediaQuery("(max-width: 768px)");
  const [connectingFlightModalOpened, setConnectingFlightOpened] = useState(false)
  const { control, watch, setValue, formState: { errors }, trigger, getValues } = useFormContext();
  const type_of_claim = watch('type_of_claim');



  const handleNext = async () => {
    const isValid = await trigger([
      "original_flight_details",
    ]);

    if (!isValid) {
      return;
    }

    setConnectingFlightOpened(true);

  }

  const {
    fields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "original_flight_details",
  });


  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Originally booked flights
        </h3>
      </div>


      <div>
        <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
          Provide details for the originally booked flight(s){" "}
          <span style={{ color: "#de8385" }}>*</span>

        </h4>
        <span className="stepper-sub-header" style={{ fontSize: "20px" }}>
          (Please enter all flights)
        </span>

        {
          type_of_claim === "cancelled" && <p className="note-wrapper" style={{ marginTop: "15px", padding: "10px 15px" }}>
            Note: Cancellation claim is not applicable if an alternative flight was provided by the airline.
          </p>
        }

      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
        <div className="file-a-claim">
          {fields.length > 0 &&
            fields.map((flight, index) => {


              return <FlightItem key={index}
                index={index}
                remove={remove}
                claimType={type_of_claim}
                defaultAirlines={defaultAirlines}
                defaultAirports={defaultAirports}
                openFlightModal={openFlightModal}
                setLoading={setLoading}
              />

            })}
        </div>
      </div>
      <div className="stepper-btn-wrapper">
        <button className="secondary-btn new-back-btn" type="button" onClick={() => setActive(c => c - 1)} >
          Back
        </button>

        <div className="add-btn-wrapper" >

          <button className="secondary-btn" type="button" onClick={() => setTemporaryOpened(true)}>
            Temporary Save
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>




        </div>
      </div>



      <Modal

        opened={connectingFlightModalOpened}
        onClose={() => { setConnectingFlightOpened(false); }}

        closeOnClickOutside={false}
        centered
        radius={isMobile ? "lg" : "xl"}
        size={"md"}

      >
        <div style={{ textAlign: "center", padding: "0px 0px 30px 0px" }}>

          {/* <h2 className="">No flight data found</h2> */}
          <p style={{ fontSize: '18px', color: 'red' }}>
            If the flight effected was part of a connecting flight journey, please enter the details of both flights in the proper sequence
          </p>

          <div className="flight-modal-btn-wrapper">
            <button type="button" className="secondary-btn" onClick={() => { append({ search_by: "airline_name", flight_class: 'Economy' }); setConnectingFlightOpened(false) }}  >Additional Flight</button>

            <button type="button" className="primary-btn" onClick={() => {

              const originalFlightData = getValues('original_flight_details');

              const hasEmptyActualFlightData = originalFlightData.some(flight =>
                [
                  flight?.actual_departure_time,
                  flight?.actual_departure_date,
                  flight?.actual_arrival_time,
                  flight?.actual_arrival_date
                ].some(value => value == null || value.trim?.() === "")
              );




              setValue('show_actual_form', hasEmptyActualFlightData);


              if (type_of_claim === 'cancelled') {
                setActive(c => c + 2);

              } else {

                if (hasEmptyActualFlightData) {

                  setValue('required_actual_flight', 'yes');
                } else {
                  setValue('required_actual_flight', '');

                }

                setActive(c => c + 1);
              }

              setValue(
                "original_flight_details",
                originalFlightData.map(flight => ({
                  ...flight,
                  triggered: false
                }))
              );
              setConnectingFlightOpened(false);

            }} >Next</button>
          </div>






        </div>
      </Modal>

    </div>
  );
};

export default OriginallyBookedFlights;
